import styled from 'styled-components';

const ProfileDescription = styled.p`
  margin: 0 0 24px;
  max-width: 930px;
  color: ${(p) => p.theme.colors.gray400};
  font-size: ${(p) => p.theme.fontSizes.base};
  line-height: 1.6;
`;

const FormLayout = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;
  font-size: ${(p) => p.theme.fontSizes.base};
  line-height: 1.6;

  > form {
    min-width: 0;
  }

  button {
    min-height: 44px;
    height: auto;
    white-space: normal;
    overflow-wrap: anywhere;
  }

  input[type='file'] {
    width: 100%;
    min-width: 0;
    margin-top: 8px;
    padding: 12px;
    border: 1px solid ${(p) => p.theme.colors.gray300};
    border-radius: ${(p) => p.theme.radii.base};
    background: ${(p) => p.theme.colors.gray000};
    color: ${(p) => p.theme.colors.gray500};
    font-size: ${(p) => p.theme.fontSizes.base};
  }

  input[type='file']::file-selector-button {
    margin-right: 12px;
    padding: 8px 12px;
    border: 1px solid ${(p) => p.theme.colors.primary500};
    border-radius: ${(p) => p.theme.radii.base};
    background: ${(p) => p.theme.colors.light};
    color: ${(p) => p.theme.colors.primary500};
    font: inherit;
    cursor: pointer;
  }
`;

const StatusPanel = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  padding: 14px 18px;
  border-left: 4px solid ${(p) => p.theme.colors.primary500};
  border-radius: ${(p) => p.theme.radii.base};
  background: ${(p) => p.theme.colors.gray000};
  color: ${(p) => p.theme.colors.gray500};

  > strong {
    color: ${(p) => p.theme.colors.primary500};
  }

  @media (max-width: 640px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

const LockedNotice = styled.p`
  margin: 0 0 30px;
  padding: 12px 16px;
  border-radius: ${(p) => p.theme.radii.base};
  background: #fff4d6;
  color: ${(p) => p.theme.colors.gray500};
`;

const FormSection = styled.section`
  padding-top: 10px;
  min-width: 0;
  overflow-wrap: anywhere;

  > p {
    margin-bottom: 16px;
  }

  > a {
    overflow-wrap: anywhere;
  }

  & + & {
    margin-top: 10px;
    padding-top: 30px;
    border-top: 1px solid ${(p) => p.theme.colors.gray100};
  }
`;

const ActionGroup = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${(p) => (p.isMobile ? 'column' : 'row')};
  gap: 12px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid ${(p) => p.theme.colors.gray100};

  > button {
    width: ${(p) => (p.isMobile ? '100%' : 'auto')};
  }
`;

export { ActionGroup, FormLayout, FormSection, LockedNotice, ProfileDescription, StatusPanel };
